import { Watchlist } from './Watchlist';
import { Chart } from './Chart';
import { OrderPanel } from './OrderPanel';
import { OpenOrders } from './OpenOrders';
import { OrderBook } from './OrderBook';
import { TimeAndSales } from './TimeAndSales';

export function Terminal() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 grid-rows-[auto_1fr_auto] gap-px bg-[var(--border-subtle)] sm:grid-rows-1 sm:grid-cols-[180px_1fr] lg:grid-cols-[200px_1fr_280px]">
      {/* Watchlist: horizontal strip on mobile, vertical sidebar on sm+ */}
      <Watchlist />

      {/* Center column: chart + (book + tape on md+) */}
      <div className="flex min-h-0 flex-col gap-px bg-[var(--border-subtle)]">
        <div className="min-h-0 flex-[2] bg-[var(--bg-surface)]">
          <Chart />
        </div>
        <div className="hidden min-h-0 flex-1 grid-cols-2 gap-px bg-[var(--border-subtle)] md:grid">
          <OrderBook />
          <TimeAndSales />
        </div>
      </div>

      {/* Right column on lg+; mobile order panel rendered as bottom sheet via different layout */}
      <div className="hidden min-h-0 flex-col gap-px bg-[var(--border-subtle)] lg:flex">
        <div className="bg-[var(--bg-surface)] p-3">
          <OrderPanel />
        </div>
        <div className="min-h-0 flex-1 bg-[var(--bg-surface)] overflow-auto">
          <OpenOrders />
        </div>
      </div>

      {/* Mobile order panel: bottom row (sm and below = always visible; below lg + above sm = collapse to right) */}
      <div className="bg-[var(--bg-surface)] p-3 lg:hidden">
        <OrderPanel />
      </div>
    </div>
  );
}
